/**
 * 사용자명 저장 관련 유틸리티 함수들
 */

// 로컬스토리지에서 저장된 사용자명 가져오기
export const getSavedUsername = (usernameType: 'email' | 'phone' | 'lpoint'): string | null => {
  try {
    const recentUsername = localStorage.getItem('recentUsername');
    if (recentUsername) {
      const parsedData = JSON.parse(recentUsername);
      const savedUsername = parsedData[usernameType];

      return savedUsername && savedUsername.trim() !== '' ? savedUsername : null;
    }
    return null;
  } catch (error) {
    console.warn('Failed to get saved username:', error);
    return null;
  }
};

// 로컬스토리지에 사용자명 저장하기
export const saveUsername = (usernameType: 'email' | 'phone' | 'lpoint', username: string): void => {
  try {
    if (!username || username.trim() === '') {
      return;
    }

    const recentUsername = localStorage.getItem('recentUsername');
    const existingData = recentUsername ? JSON.parse(recentUsername) : {};

    // 현재 타입의 유저네임 저장
    existingData[usernameType] = username.trim();
    localStorage.setItem('recentUsername', JSON.stringify(existingData));
  } catch (error) {
    console.warn('Failed to save username:', error);
  }
};

// 로컬스토리지에서 특정 타입의 사용자명 제거하기
export const removeSavedUsername = (usernameType: 'email' | 'phone' | 'lpoint'): void => {
  try {
    const recentUsername = localStorage.getItem('recentUsername');
    if (recentUsername) {
      const parsedData = JSON.parse(recentUsername);
      delete parsedData[usernameType];

      // 다른 타입의 데이터가 있으면 업데이트, 없으면 완전 삭제
      if (Object.keys(parsedData).length > 0) {
        localStorage.setItem('recentUsername', JSON.stringify(parsedData));
      } else {
        localStorage.removeItem('recentUsername');
      }
    }
  } catch (error) {
    console.warn('Failed to remove saved username:', error);
  }
};

// checkSnsLogin에서 로그인 타입 추출하기
export const getLoginTypeFromStorage = (): 'email' | 'phone' | 'lpoint' | null => {
  try {
    const checkSnsLogin = localStorage.getItem('checkSnsLogin');
    if (checkSnsLogin) {
      switch (checkSnsLogin) {
        case 'B':
          return 'email';
        case 'P':
          return 'phone';
        case 'L':
          return 'lpoint';
        default:
          return null;
      }
    }
    return null;
  } catch (error) {
    console.warn('Failed to get login type from storage:', error);
    return null;
  }
};